webpackJsonp([13],{

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(802)
}
var Component = __webpack_require__(184)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(805),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02911806",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    var goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(803);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("426c79f6", content, true, {});

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".main[data-v-02911806]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif!important}img[data-v-02911806]{display:block;margin:0}.downloaarticle-main-title[data-v-02911806]{padding-bottom:22px;margin-top:25px;color:#16ac3a;font-size:31px;font-weight:800;text-align:center}.download-article-bold[data-v-02911806]{display:inline-block;width:270px;margin-bottom:17px}.download-title[data-v-02911806]{width:175px;margin:0 auto;margin-top:10px}.downloaarticle-title[data-v-02911806]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif!important;padding:22px 0;color:#16ac3a;font-size:24px;font-weight:800;text-align:center}.downloaarticle-title[data-v-02911806]:first-of-type{border-top:1px solid #f4f6f8}.download-btn[data-v-02911806]{width:150px;height:45px;margin:0 auto;margin-bottom:20px;margin-top:10px}.download-article[data-v-02911806]{padding:0 10px 10px;color:#2d2f32;font-size:16px;text-align:center}.download-article[data-v-02911806]:first-of-type{padding:0 10px 26px}.download-article .green[data-v-02911806]{color:#16ac3a}.download-bottom[data-v-02911806]{background:#eff1f4;margin-top:-1px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite-yinni/src/pages/AppDownload.vue"],"names":[],"mappings":"AACA,uBACI,+DAAuE,CAC1E,AACD,qBACI,cAAe,AACf,QAAU,CACb,AACD,4CACI,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,wCACI,qBAAsB,AACtB,YAAa,AACb,kBAAoB,CACvB,AACD,iCACI,YAAa,AACb,cAAe,AACf,eAAiB,CACpB,AACD,uCACI,gEAAuE,AACvE,eAAgB,AAChB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,qDACI,4BAA8B,CACjC,AACD,+BACI,YAAa,AACb,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,eAAiB,CACpB,AACD,mCACI,oBAAqB,AACrB,cAAe,AACf,eAAgB,AAChB,iBAAmB,CACtB,AACD,iDACI,mBAA0B,CAC7B,AACD,0CACI,aAAe,CAClB,AACD,kCACI,mBAAoB,AACpB,eAAiB,CACpB","file":"AppDownload.vue","sourcesContent":["\n.main[data-v-02911806] {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n}\nimg[data-v-02911806] {\n    display: block;\n    margin: 0;\n}\n.downloaarticle-main-title[data-v-02911806] {\n    padding-bottom: 22px;\n    margin-top: 25px;\n    color: #16ac3a;\n    font-size: 31px;\n    font-weight: 800;\n    text-align: center;\n}\n.download-article-bold[data-v-02911806] {\n    display: inline-block;\n    width: 270px;\n    margin-bottom: 17px;\n}\n.download-title[data-v-02911806] {\n    width: 175px;\n    margin: 0 auto;\n    margin-top: 10px;\n}\n.downloaarticle-title[data-v-02911806] {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n    padding: 22px 0;\n    color: #16ac3a;\n    font-size: 24px;\n    font-weight: 800;\n    text-align: center;\n}\n.downloaarticle-title[data-v-02911806]:first-of-type {\n    border-top: 1px solid #f4f6f8;\n}\n.download-btn[data-v-02911806] {\n    width: 150px;\n    height: 45px;\n    margin: 0 auto;\n    margin-bottom: 20px;\n    margin-top: 10px;\n}\n.download-article[data-v-02911806] {\n    padding: 0 10px 10px;\n    color: #2d2f32;\n    font-size: 16px;\n    text-align: center;\n}\n.download-article[data-v-02911806]:first-of-type {\n    padding: 0 10px 26px 10px;\n}\n.download-article .green[data-v-02911806] {\n    color: #16ac3a;\n}\n.download-bottom[data-v-02911806] {\n    background: #eff1f4;\n    margin-top: -1px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(499);

exports.default = {
    data: function data() {
        return {
            is_opreamini: false
        };
    },
    mounted: function mounted() {
        (0, _util.record)('msite/download?from=' + (0, _util.getQueryString)('from'));
        ga('send', 'event', 'downloadPage', 'enter', (0, _util.getQueryString)('from'));
        var utilObj = __webpack_require__(499);
        if (!utilObj.checkOperamini()) {
            this.jumpUrl();
        }
        this.is_opreamini = utilObj.checkOperamini();
    },

    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(499);
            utilObj.jumpUrl(true);
        }
    }
};

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h1', {
    staticClass: "downloaarticle-main-title"
  }, [_vm._v("Selamat!")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Anda telah mengunduh Aplikasi All Football, yang merupakan versi terbaru dari situs web ini dan akan memberikan pengalaman penggunaan yang lebih baik.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("1. Unduh aplikasi")]), _vm._v(" "), (!_vm.is_opreamini) ? _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Jika Anda secara tidak sengaja membatalkan unduhan, Anda dapat klik tautan di bawah ini untuk mengunduh kembali.\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "download-btn",
    attrs: {
      "src": __webpack_require__(806)
    },
    on: {
      "click": _vm.jumpUrl
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(807),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("2. Atur pengaturan telepon")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(808),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("3. Tidak berhasil")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(809),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_c('b', {
    staticClass: "download-article-bold"
  }, [_vm._v("Berikut adalah beberapa petunjuk tentang cara menginstal aplikasi kami.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Jika muncul peringatan biasa tentang kemungkinan kerusakan perangkat, konfirmasi "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"OK\"")]), _vm._v(" - Kami menjamin bahwa aplikasi kami pasti tidak akan merusak perangkat Anda.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Anda akan menemukan aplikasi yang diunduh di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifikasi\"")]), _vm._v(" atau di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Unduhan\"")]), _vm._v(" folder. Klik pada itu, pilih "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Instal\"")]), _vm._v(" dan konfirmasi.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        Anda akan menemukan aplikasi yang diunduh di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifikasi\"")]), _vm._v(" atau di "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Unduhan\"")]), _vm._v(" folder. Klik pada itu, pilih "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Instal\"")]), _vm._v(" dan konfirmasi.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-bottom"
  }, [_c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("Tidak berhasil?")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n            Coba lagi mengikuti petunjuk di atas. Atau unduh versi aplikasi terbaru dari "), _c('a', {
    attrs: {
      "href": "https://at.umeng.com/SbK5Lf"
    }
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("Google_Play")])]), _vm._v(".\n        ")])])
}]}

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_btn.348b20d.png";

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_pic1.eafcd28.png";

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_pic2.b951f50.png";

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_pic3.844e103.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.fa10d9f7c34fdb0dbd64.js